var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6015 10.7048C15.4987 10.7048 15.3971 10.6993 15.2969 10.6884C14.9264 10.6482 14.8077 10.2123 14.9953 9.89026C15.4381 9.13023 15.694 8.23222 15.694 7.27013C15.694 6.47944 15.5212 5.73202 15.2138 5.06891C15.0562 4.72897 15.2187 4.30478 15.5934 4.30372C15.5961 4.30371 15.5988 4.30371 15.6015 4.30371C17.2505 4.30371 18.5873 5.73665 18.5873 7.50427C18.5873 9.2719 17.2505 10.7048 15.6015 10.7048Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.3581C21 16.0875 20.5237 16.6495 19.7333 17.049C19.4047 17.2151 19.0342 16.9579 18.9254 16.6062C18.4734 15.1443 16.8726 13.6859 14.6938 12.877C14.177 12.6852 14.1445 11.9734 14.6912 11.9029C14.987 11.8648 15.2911 11.8446 15.6013 11.8446C18.5827 11.8446 21 13.7149 21 15.3581Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2027 11.5403C12.4028 11.5403 14.1864 9.62847 14.1864 7.27013C14.1864 4.9118 12.4028 3 10.2027 3C8.00255 3 6.21899 4.9118 6.21899 7.27013C6.21899 9.62847 8.00255 11.5403 10.2027 11.5403Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2025 21C6.22466 21 3 19.9409 3 17.7486C3 15.5562 6.22465 13.0609 10.2025 13.0609C14.1803 13.0609 17.4053 15.5562 17.4053 17.7486C17.4053 19.9409 14.1803 21 10.2025 21Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupFilled);
export default __webpack_public_path__ + "static/media/group-filled.69c1c39e95931a67e2482fe61731afcf.svg";
export { ForwardRef as ReactComponent };